import { publicApi } from './index';
import {
  setCatalogueForCountry,
  upsertCatalogueRecord,
} from '../../slices/giftCardCatalogue';

export const globetopperPublicApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    getGiftCardCatalogue: builder.query({
      query: (countryCode) => {
        const normalizedCountryCode = countryCode?.trim()?.toUpperCase() || '';
        return {
          url: `/globetopper/globe-topper-giftcards${normalizedCountryCode ? `?countryCode=${normalizedCountryCode}` : ''}`,
          method: 'GET',
        };
      },
      async onQueryStarted(countryCode, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
        const normalizedCountryCode = countryCode?.trim()?.toUpperCase() || '';
        const records = data?.records || [];
        dispatch(setCatalogueForCountry({ countryCode: normalizedCountryCode, records }));
      },
      // Force refetch when argument changes
      refetchOnMountOrArgChange: true,
    }),
    getGiftCardById: builder.query({
      query: (productId) => ({
        url: `/globetopper/giftcard/${productId}`,
        method: 'GET',
      }),
      async onQueryStarted(_productId, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
          const countryCode =
            data?.detailedInfo?.operator?.country?.iso2 ||
            data?.detailedInfo?.operator?.country?.code ||
            data?.countryCode ||
            '';
          dispatch(
            upsertCatalogueRecord({
              countryCode: countryCode ? String(countryCode).toUpperCase() : '',
              record: data,
            }),
          );
      },
    }),
    getGlobetopperCountries: builder.query({
      query: () => ({
        url: '/globetopper/countries',
        method: 'GET',
      }),
      transformResponse: (response) => {
        if (!Array.isArray(response?.records)) {
          throw new Error('Invalid countries response: expected records array');
        }
        return response.records;
      },
    }),
  }),
});

export const {
  useGetGiftCardCatalogueQuery,
  useGetGiftCardByIdQuery,
  useGetGlobetopperCountriesQuery,
} = globetopperPublicApi;
